import { makeStyles } from '@material-ui/core';
import { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './style.scss';

const pagination = {
    clickable: true,
};

export default function HighlightCollection(props) {
    const { highlightCollectionData } = props;
    const useStyles = makeStyles((theme) => ({
        sliderContainer: {
            // maxHeight: 'calc(100vh - 100px)'
        },
        slideImage: {
            backgroundSize: 'cover',
            borderRadius: '0.4rem',
        },
        overlayContainer: {
            bottom: '11%',
            left: '5%',
            zIndex: 'inherit',
            maxWidth: '90%',
        },
        styleTitle: {
            fontFamily: 'EB Garamond',
            fontSize: `32px`,
            color: themes.palette.common.white,
        },
        button: {
            border: 0,
            fontSize: `12px`,
            background: themes.palette.primary.main,
            paddingTop: `10px`,
            paddingBottom: `10px`,
            color: themes.palette.common.white,
        },
    }));
    const classes = useStyles();
    const history = useHistory();

    const [, setSwiperInstance] = useState<SwiperCore>();
    const imageDiv = useRef<HTMLDivElement>(null);
    const [imageHeight, setImageHeight] = useState(0);

    useEffect(() => {
        if (imageDiv.current) {
            let dynamicHeight = imageDiv?.current?.offsetWidth / 1.167;
            setImageHeight(dynamicHeight);
        }
    }, []);

    const navigateToHighlight = () => {
        history.push(PATH.HIGHLIGHT, {
            title: highlightCollectionData?.getHighlightCollections?.title,
            query: highlightCollectionData?.getHighlightCollections?.url,
        });
    };

    if (
        !highlightCollectionData?.getHighlightCollections ||
        !highlightCollectionData?.getHighlightCollections?.imageUrl
    ) {
        return null;
    }

    return (
        <div style={{ paddingTop: `24px` }} className="highlightContainer">
            <Swiper
                direction="horizontal"
                onSwiper={(swiper) => setSwiperInstance(swiper)}
                className="mx-3"
                pagination={pagination}
            >
                {highlightCollectionData?.getHighlightCollections.imageUrl.map((item, index) => {
                    return (
                        <SwiperSlide key={index} className={`${classes.sliderContainer} d-flex justify-content-center`}>
                            <div
                                style={{
                                    backgroundImage: `url(${item})`,
                                    //     backgroundImage:
                                    //         `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
                                    // url(${item})`,
                                    height: imageHeight,
                                }}
                                ref={imageDiv}
                                onClick={navigateToHighlight}
                                className={`${classes.slideImage} w-100`}
                            ></div>
                        </SwiperSlide>
                    );
                })}
                <div className={`position-absolute ${classes.overlayContainer}`} onClick={navigateToHighlight}>
                    <div className={classes.styleTitle}>{highlightCollectionData?.getHighlightCollections?.title}</div>
                    <button className={`${classes.button} py-2 px-3 rounded-pill`} onClick={navigateToHighlight}>
                        {' '}
                        {highlightCollectionData?.getHighlightCollections?.buttonCaption || 'Shop the collection'}
                    </button>
                </div>
            </Swiper>
        </div>
    );
}
